import { useOptionalHotelDataContext } from "@/app/lib/context/HotelDataContext";
import { HotelImageList } from "@/app/ui/hotel/HotelImageList";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images",
)({
  component: RouteComponent,
  staticData: {
    hotelStep: {
      presentationMode: "modal",
      stepNumber: 1,
    },
    drawer: false,
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  const { data: hotel } = useOptionalHotelDataContext();

  if (!hotel) {
    // If the app fails to load the hotel data or to pass search data, redirect to the hotel list page
    // This is a fallback in case the user tries to access this page directly
    // It's unlikely that this will happen, but it's a good fallback to have
    // Avoids the need to handle these cases in the other components
    return <Navigate to=".." from={Route.fullPath} />;
  }

  return (
    <HotelImageList
      images={hotel.imagesUrls.map((url) => ({ url, name: hotel.name }))}
      onImageClick={(index) =>
        navigate({ to: "./fullscreen", search: { index } })
      }
    />
  );
}
